// Solana color palette
const theme = {
  colors: {
    primary: '#9945FF',
    secondary: '#14F195',
    accent: '#00C2FF',
    background: '#121212',
    text: '#FFFFFF',
    gradient: 'linear-gradient(90deg, #9945FF 0%, #14F195 100%)',
  },
  fonts: {
    main: "'Inter', sans-serif",
  },
};

export default theme; 